export const LIMIT_THEME_PAGE_MANAGEMENT_PAGINATION = 5;
